import CryptoJS from "crypto-js";
export const decrypt = (text) => {
	const decrypted = CryptoJS.AES.decrypt(text, "openge.org.cn", {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	return decrypted.toString(CryptoJS.enc.Utf8);
};